/* Design Studio link helpers â€” 3Blades Maker Lab
   Most redirects are handled server-side via Shopify URL redirects.
   This script only handles two things the server can't:
   1. Slideshow buttons that link to /pages/design-studio without product params
   2. Collection cards inside carousels (carousel eats click events) */
(function(){
  /* Slideshow button text â†’ product param */
  var btnMap = {
    'create your crystal': '?product=crystals',
    'open the coaster designer': '?product=coasters',
    'design your board': '?product=boards'
  };

  function rewriteSlideButtons() {
    document.querySelectorAll('a[href*="/pages/design-studio"]').forEach(function(a) {
      var text = (a.textContent || '').trim().toLowerCase();
      for (var label in btnMap) {
        if (text === label && a.getAttribute('href').indexOf('?') === -1) {
          a.setAttribute('href', '/pages/design-studio' + btnMap[label]);
        }
      }
    });
  }

  /* Collection cards inside carousels â€” carousel JS eats clicks,
     so we intercept at capture phase and navigate directly */
  function fixCollectionCards() {
    document.addEventListener('click', function(e) {
      var card = e.target.closest('.collection-card');
      if (!card) return;
      var link = card.querySelector('.collection-card__link');
      if (!link) return;
      var href = link.getAttribute('href');
      /* Design Studio collection â†’ landing page */
      if (href === '/collections/design-studio') href = '/pages/design-studio';
      if (href && href !== '#') {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = href;
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { rewriteSlideButtons(); fixCollectionCards(); });
  } else {
    rewriteSlideButtons(); fixCollectionCards();
  }
  /* Watch for dynamically loaded slideshow content */
  var observer = new MutationObserver(rewriteSlideButtons);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 5000);
})();
